import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import type { ChildRouteContext } from "@/root";

import { chartTypes } from "@/modules/chart/shared/constants";
import Chart from "@/modules/chart/user/components/Chart";

export const Route = createFileRoute("/_panel/_chart/chart/charts/$type")({
  component: Component,
  parseParams: (params) => ({
    type: z.enum(chartTypes).parse(params.type),
  }),
  stringifyParams: ({ type }) => ({ type: `${type}` }),
  beforeLoad: () =>
    ({
      crumb: [],
    }) satisfies ChildRouteContext,
});

function Component() {
  const { type } = Route.useParams();

  return <Chart type={type} />;
}
